import { SelectableMenuItem } from '@/components/table/toolbar/selectable-menu-item';
import { connectColors } from '@/theme/colors';
import { Button, Menu } from '@lego/connect-components-react';
import { useRef, useState } from 'react';
import { SimulationView } from '../../simulation-view-constants';
import { useUserRole } from '@/hooks/use-user-role';

type UserGroupView = 'core' | 'non-core';

type SimulationViewDropdownProps = {
  selectedView: SimulationView;
  setSelectedView: (view: SimulationView) => void;
  userGroupView: UserGroupView;
  setUserGroupView: (view: UserGroupView) => void;
};

const USER_GROUP_OPTIONS: { label: string; value: UserGroupView }[] = [
  { label: 'Core', value: 'core' },
  { label: 'Non-Core', value: 'non-core' },
];

const SimulationViewDropdown = ({
  selectedView,
  setSelectedView,
  userGroupView,
  setUserGroupView,
}: SimulationViewDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const { isAdmin } = useUserRole();
  const viewOptions = Object.values(SimulationView).filter(
    (view) => isAdmin || view !== SimulationView.KEYFIGURES,
  );

  return (
    <>
      <Button
        ref={anchorRef}
        appearance="ghost"
        size="small"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="View selector"
        iconName="chevron-down-solid"
        iconPosition="end"
        style={{ color: connectColors.core.slate[1200] }}
      >
        {selectedView}
      </Button>
      <Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        anchorRef={anchorRef}
        aria-labelledby="main-view-menu"
        offset={4}
      >
        <Menu.Section id="views" title="">
          {viewOptions.map((option) => (
            <SelectableMenuItem
              key={option}
              value={option}
              label={option}
              isSelected={selectedView === option}
              onClick={() => {
                setSelectedView(option);
                setIsOpen(false);
              }}
            />
          ))}
        </Menu.Section>
        <Menu.Section id="user-group-view" title="USER GROUP VIEW">
          {USER_GROUP_OPTIONS.map((option) => (
            <SelectableMenuItem
              key={option.value}
              value={option.value}
              label={option.label}
              isSelected={userGroupView === option.value}
              onClick={() => {
                setUserGroupView(option.value);
                setIsOpen(false);
              }}
            />
          ))}
        </Menu.Section>
      </Menu>
    </>
  );
};

export default SimulationViewDropdown;
